import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const wizefleeteldConfig: TSPConfig = {
  key: 'wizefleeteld',
  name: 'WizefleetELD',
  imageName: 'WizeFleetELD',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request an API key from WizefleetELD support, then enter it below.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default wizefleeteldConfig;
